// TalkRobin: the account's plan (Free, Pro, ...), its limits, features and
// usage, from /api/v1/accounts/:id/plan. Loaded by usePlanSync.
import TalkrobinPlanAPI from 'dashboard/api/talkrobinPlan';

export const types = {
  SET_PLAN: 'SET_PLAN',
  SET_UI_FLAG: 'SET_UI_FLAG',
};

export const state = {
  record: null,
  uiFlags: { isFetching: false, isRequestingUpgrade: false },
};

export const getters = {
  getPlan: $state => $state.record,
  getUIFlags: $state => $state.uiFlags,
  // Until the plan has loaded nothing is locked, so pages don't flash
  // upgrade prompts at paying customers.
  hasFeature: $state => feature =>
    !$state.record || Boolean($state.record.plan.features[feature]),
  // null = unlimited
  getLimit: $state => key => $state.record?.plan.limits[key] ?? null,
  getUsage: $state => key => $state.record?.usage[key] ?? 0,
  isLimitReached: $state => key => {
    const limit = $state.record?.plan.limits[key];
    return limit != null && $state.record.usage[key] >= limit;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const { data } = await TalkrobinPlanAPI.get();
      commit(types.SET_PLAN, data);
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },
  async requestUpgrade({ commit }, plan) {
    commit(types.SET_UI_FLAG, { isRequestingUpgrade: true });
    try {
      const { data } = await TalkrobinPlanAPI.requestUpgrade(plan);
      commit(types.SET_PLAN, data);
    } finally {
      commit(types.SET_UI_FLAG, { isRequestingUpgrade: false });
    }
  },
};

export const mutations = {
  [types.SET_PLAN]($state, record) {
    $state.record = record;
  },
  [types.SET_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
